import { getStore } from '../store/SharePointItemsViewNavigationLocationStore';

export const getSharePointItemsViewCurrentPath = (groupSmtpAddress: string) => {
    groupSmtpAddress = groupSmtpAddress.toLowerCase();
    const store = getStore();
    if (store.has(groupSmtpAddress)) {
        return store.get(groupSmtpAddress).currentPath;
    }

    return undefined;
};

export const getSharePointItemsViewTargetPath = (groupSmtpAddress: string) => {
    groupSmtpAddress = groupSmtpAddress.toLowerCase();
    const store = getStore();
    if (store.has(groupSmtpAddress)) {
        return store.get(groupSmtpAddress).targetPath;
    }

    return undefined;
};
